import { useState, useEffect, useContext } from "react";
import placeholder from "../inc/placeholder.jpg";
import { SiteContext } from "../contexts/SiteContext";
import { ViewContext } from "../contexts/ViewContext";
import {
	Paper,
	Typography,
	Grid,
	Card,
	CardMedia,
	CardContent,
	CardActionArea,
	makeStyles,
	Fade,
	Button,
	useTheme,
	Tooltip,
	Hidden,
	IconButton,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewGridIcon from "@material-ui/icons/ViewModule";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: "1rem",
		marginBottom: "1rem",
		//marginTop: "1rem",
	},
	media: {
		paddingBottom: "100%",
	},
	horizCard: {
		marginBottom: "1rem",
	},
	link: {
		color: "black",
		textDecoration: "none",
	},
	horizCardActionArea: {
		display: "flex",
		justifyContent: "start",
	},
	horizMedia: {
		paddingBottom: "20%",
		paddingRight: "20%",
	},
	horizCardContent: {
		padding: "0 1rem",
	},
	unitContent: {
		flexGrow: 1,
		padding: ".5rem",
	},
}));

function Units() {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);
	const { unitsView, setUnitsView } = useContext(ViewContext);
	const [units, setUnits] = useState();
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		const fetchData = async () => {
			const url = `${process.env.REACT_APP_API_URL}/units?sort=sortDate&site=${selectedSite._id}`;
			const res = await fetch(url, { credentials: "include" });
			const allUnits = await res.json();
			if (allUnits.success) {
				setUnits(allUnits.data.filter((unit) => !unit.parent));
			} else {
				console.log(allUnits.error);
			}
		};
		fetchData();
		setLoading(false);
	}, [selectedSite._id]);

	if (loading || !unitsView) {
		return "Loading...";
	}

	return (
		<>
			{units && units.length > 0 && (
				<Fade in={!loading}>
					<Paper className={classes.paper} style={{ position: 'relative' }}>
						<Typography
							style={{ marginBottom: "1rem" }}
							component="h3"
							variant="h6"
							align="center"
						>
							Units
						</Typography>
						<div
							style={{
								display: "flex",
								justifyContent: "flex-end",
								position: 'absolute',
								top: '.5rem',
								right: '.5rem'
							}}
						>
							<Hidden smDown>
								{unitsView === "grid" ? (
									<Tooltip
										title="View units as a list"
										aria-label="View units as a list"
										placement="top"
									>
										<IconButton
											aria-label="View the units in a list format"
											onClick={() => setUnitsView("list")}
											variant="contained"
										>
											<ViewListIcon />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip
										title="View units as a grid"
										aria-label="View units as a grid"
										placement="top"
									>
										<IconButton
											aria-label="View the units in a grid format"
											onClick={() => setUnitsView("grid")}
											variant="contained"
										>
											<ViewGridIcon />
										</IconButton>
									</Tooltip>
								)}
							</Hidden>
						</div>

						<Hidden smDown>
							{unitsView === "list" ? (
								<UnitsList units={units} />
							) : (
								<UnitsGrid units={units} />
							)}
						</Hidden>

						{/*On mobile devices, only allow displaying the UnitsGrid*/}
						<Hidden mdUp>
							<UnitsGrid units={units} />
						</Hidden>
					</Paper>
				</Fade>
			)}
		</>
	);
}

//----------
// GRID VIEW
//----------

function UnitsGrid({ units }) {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);

	if (!units) {
		return "Please pass units to the UnitsGrid component...";
	}

	return (
		<Grid container spacing={3}>
			{units.map((unit, index) => {
				return (
					<Grid item key={index} xs={12} sm={6} md={4} lg={3}>
						<Card className={classes.card} elevation={0} aria-label>
							<Link
								className={classes.link}
								to={`/${selectedSite.slug}/units/${unit.slug}`}
							>
								<CardActionArea>
									<CardMedia
										className={classes.media}
										image={
											unit.featuredImage
												? `${process.env.REACT_APP_FILE_URL}/${unit.featuredImage.thumbnailName}`
												: placeholder
										}
										title={unit.name}
									/>
									<CardContent className={classes.unitContent}>
										<Typography align="center">{unit.name}</Typography>
									</CardContent>
								</CardActionArea>
							</Link>
						</Card>
					</Grid>
				);
			})}
		</Grid>
	);
}

//----------
// LIST VIEW
//----------
//
function UnitsList({ units }) {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);

	if (!units) {
		return "Please pass units to the UnitsList component...";
	}

	return (
		<>
			{units.map((unit, index) => {
				return (
					<Card key={index} className={classes.horizCard}>
						<Link
							className={classes.link}
							to={`/${selectedSite.slug}/units/${unit.slug}`}
						>
							<CardActionArea className={classes.horizCardActionArea}>
								<CardMedia
									className={classes.horizMedia}
									image={
										unit.featuredImage
											? `${process.env.REACT_APP_FILE_URL}/${unit.featuredImage.thumbnailName}`
											: placeholder
									}
									title={unit.name}
								/>
								<CardContent className={classes.horizCardContent}>
									<Typography variant="h6" component="h4">
										{unit.name}
									</Typography>
									<Typography
										component="p"
										className={classes.unitDescription}
										dangerouslySetInnerHTML={{
											__html: unit.shortDescription,
										}}
									></Typography>
								</CardContent>
							</CardActionArea>
						</Link>
					</Card>
				);
			})}
		</>
	);
}

export default Units;
